import React from "react";
import { Box, AppBar, Toolbar, IconButton, Typography } from "@mui/material";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { FormattedMessage } from "react-intl";
import { ProfileNavigation } from "./ProfileNavigation";
import { LoggedInSidebar } from "../../../components/sidebars/logged-in-sidebar/logged-in-sidebar";

export const MobileNavigation = ({ selectedArea, onNavigation }) => (
  <Box
    sx={{
      width: "100%",
      height: "calc(100vh - 60px)", // Account for header height
      backgroundColor: "background.paper",
      position: "fixed",
      top: 60, // Position below header
      left: 0,
      zIndex: 1000,
      overflow: "auto",
      boxSizing: "border-box",
    }}
  >
    <ProfileNavigation isMobile={true} onNavigation={onNavigation} />
  </Box>
);

export const MobileContent = ({
  onBackToNavigation,
  currentPageTitle,
  children,
}) => (
  <Box
    sx={{
      flexGrow: 1,
      display: "flex",
      flexDirection: "column",
      width: "100%",
      maxWidth: "100%",
      overflow: "hidden",
      boxSizing: "border-box",
    }}
  >
    {/* Mobile App Bar */}
    <AppBar position="static" color="default" elevation={1}>
      <Toolbar sx={{ minHeight: 56 }}>
        <IconButton
          edge="start"
          color="inherit"
          onClick={onBackToNavigation}
          sx={{ mr: 2 }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography
          variant="h6"
          component="div"
          sx={{
            flexGrow: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            minWidth: 0,
          }}
        >
          <FormattedMessage id={currentPageTitle} />
        </Typography>
      </Toolbar>
    </AppBar>

    {/* Content Area */}
    <Box
      sx={{
        flexGrow: 1,
        overflow: "auto",
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
      }}
    >
      {children}
    </Box>
  </Box>
);

export const ProfilePageMobileLayout = ({
  showMobileNavigation,
  selectedArea,
  onNavigation,
  onBackToNavigation,
  currentPageTitle,
  children,
}) => (
  <Box
    sx={{
      display: "flex",
      minHeight: "100vh",
      width: "100%",
      maxWidth: "100%",
      overflow: "hidden",
      boxSizing: "border-box",
      position: "relative",
      pt: "70px", // Add top padding to account for fixed header
    }}
  >
    {/* Mobile Navigation - Show when showMobileNavigation is true */}
    {showMobileNavigation && (
      <MobileNavigation
        selectedArea={selectedArea}
        onNavigation={onNavigation}
      />
    )}

    {/* Mobile Content - Show when showMobileNavigation is false */}
    {!showMobileNavigation && (
      <MobileContent
        onBackToNavigation={onBackToNavigation}
        currentPageTitle={currentPageTitle}
      >
        {children}
      </MobileContent>
    )}

    <LoggedInSidebar />
  </Box>
);
